import React from "react";
import TitlePart from "../../../components/TitlePart/TitlePart";

import img1 from "../../../assets/images/img1.jpeg";

import { useStyles } from "./about.styles";

function About() {
  const styles = useStyles();
  return (
    <div className={styles.about} id="About">
      <TitlePart num={"02."}>About Me</TitlePart>
      <div className="container">
        <div className="description">
          <p>
            As a passionate software engineer with six years of education at the University of Manouba and the University of Tunis El Manar, I am deeply motivated by the dynamic world of technology and software development. My journey has been driven by a commitment to building robust, scalable platforms that create a meaningful impact.
          </p>
          <p>
            Over the past three years, I have gained hands-on experience through internships with leading startups and organizations, such as{" "}
            <a href="https://www.tritux.com/en/principale-english/">Tritux Group</a>,{" "}
            <a href="https://www.innovup.com.tn" className="imp">INNOVUP</a>, and{" "}
            <a href="https://ftdes.net" className="imp">FTDES</a>. These experiences have exposed me to complex, high-impact projects, providing valuable industry insights and fostering both my professional and personal growth.
          </p>

          <p>Feel free to explore my portfolio to see some of my recent projects. If you’re interested in collaborating, don’t hesitate to get in touch!</p>

        </div>
        <div className="img-part">
          <div className="img-container">
            <div
              className="img"
              style={{ backgroundImage: `url(${img1})` }}
            ></div>
            <div className="box-border"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
